import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { StudentBookingStudentDetails } from '../_models/student-bookings/student-booking-student-details';
import { DropDownListElement } from '../shared/utility/drop-down-list-element';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { StudentSearchModalComponent } from '../shared/student-search/student-search-modal.component';
import { EditLearningSectionModalComponent } from '../tutor-reports/tutor-report-timeline/modals/edit-learning-section-modal/edit-learning-section-modal.component';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AttendancesService } from '../_services/shared/attendances.service';
import { TimelineSectionStudentInfo } from '../_models/timeline-models/timeline-section-student-info.model';
import { StudentBookingsService } from '../_services/student-bookings/student-bookings.service';
import { GenerateStudentAccessModalData } from '../_models/grant-student-access/generate-student-access-modal-data.model';
import { GenerateStudentAccessModalComponent } from '../students/generate-student-access-modal/generate-student-access-modal.component';

@Component({
    selector: 'student-booking-student-details',
    templateUrl: 'student-booking-student-details.component.html',
    styleUrls: ['student-booking-student-details.component.css'],
    standalone: false
})
export class StudentBookingStudentDetailsComponent implements AfterViewInit {
  @ViewChild('studentDetailsForm', { static: false }) studentForm: any;
  @Input() public placementId: number;
  @Input() public status: string;
  @Input() public model: StudentBookingStudentDetails;
  @Input() public studentIndex: number;
  @Input() public disabled: boolean;
  @Input() public clientId: boolean;
  @Input() public lockStudents: boolean;
  @Input() public commentsMandatory: boolean;
  @Input() public subject: string;
  @Input() public studentIds: number[];
  @Output() onDataChanged = new EventEmitter<boolean>();
  @Output() studentChanged = new EventEmitter<number>();

  public attendanceList: DropDownListElement[];
  public commentIsRequired: boolean = false;
  public reasonDescriptionIsRequired: boolean = false;
  public form: UntypedFormGroup;

  constructor(
    public dialog: MatDialog,
    private readonly attendanceService: AttendancesService,
    private router: Router,
    private readonly studentBookingsService: StudentBookingsService
  ) {
    attendanceService.getAttendanceList().subscribe(data => {
      this.attendanceList = data;
    });
  }

  public openStudentSearch() {
    const dialog = this.dialog.open(StudentSearchModalComponent, {
      data: {
        clientId: this.clientId,
        excludeStudentIdsFromSearch: this.studentIds
      }
    });
    dialog.componentInstance.addStudent.subscribe(student => {
      this.model.studentFullName = student.studentDetailItem.firstName + " " + student.studentDetailItem.surname;
      this.model.studentId = student.studentId;
      this.model.sessionsStart = null;
      this.model.sessionsEnd = null;
      this.model.attendance = 'Present';
      this.studentChanged.emit(student.studentId);
      this.setAttendanceValidation();
      this.studentBookingsService.retrieveStudentProgression([this.model.studentId], this.subject, this.placementId).subscribe(data => {
        this.model.latestLearningSection = { lastAssessmentScore: data[0].assessmentScore, lastProgress: data[0].currentProgress, lastTarget: data[0].lastTarget };
      });
      dialog.close();
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.form = this.studentForm.form;
      this.setAttendanceValidation();
    });
  }

  public setAttendanceValidation() {
    let commentsValidator = [];
    // comments section
    if ((this.model.attendance == 'Present' || this.model.attendance == 'Late') && this.commentsMandatory && this.model.studentId != 0) {
      commentsValidator = [Validators.required, Validators.minLength(100), Validators.maxLength(3000)];
      this.commentIsRequired = true;
    } else {
      commentsValidator = [Validators.maxLength(3000)];
      this.commentIsRequired = false;
    }
    this.studentForm.form.controls['learnerComments'].setValidators(Validators.compose(commentsValidator));
    this.studentForm.form.controls['learnerComments'].updateValueAndValidity();

    // attendance type reason section
    let reasonDescriptionValidator = [];
    // comments section
    if ((this.model.attendance == 'Absent' || this.model.attendance == 'Late') && this.model.studentId != 0) {
      reasonDescriptionValidator = [Validators.required, Validators.minLength(4), Validators.maxLength(3000)];
      this.reasonDescriptionIsRequired = true;
    } else {
      reasonDescriptionValidator = [Validators.maxLength(3000)];
      this.reasonDescriptionIsRequired = false;
    }
    this.studentForm.form.controls['reasonDescription'].setValidators(Validators.compose(reasonDescriptionValidator));
    this.studentForm.form.controls['reasonDescription'].updateValueAndValidity();
    
  }

  public addStudentLearningSection() {
    if (this.model.studentId != 0) {
      const dialogRef = this.dialog.open(EditLearningSectionModalComponent, {
        data: {
          editMode: true,
          timelineSection: null,
          add: true,
          students: [new TimelineSectionStudentInfo(this.model.studentId, this.model.studentFullName)],
          subject: this.subject,
          placementId: this.placementId,
        },
        panelClass: 'my-timeline-edit-dialog'
      });
      dialogRef.afterClosed().subscribe((reload: boolean) => {
        if (reload) {
          this.onDataChanged.emit(true);
        }
      });
    }
  }

  public viewStudentTimeline(): void {
    if (this.model.studentId != 0) {
      this.router.navigate(['/timeline', this.placementId], {
        state: {
          placementId: this.placementId,
          timelineStudent: new TimelineSectionStudentInfo(this.model.studentId, this.model.studentFullName),
          subject: this.subject,
          clientId: this.clientId
        } 
      });
    }
  }
  
  public grantStudentAccess(): void {
    let data = new GenerateStudentAccessModalData();
    data.studentId = this.model.studentId;
    data.showSignUpEmailButton = false;
    data.showWebsiteLinkButton = true;

    const dialogRef = this.dialog.open(GenerateStudentAccessModalComponent, {
      data: data,
      panelClass: 'my-dialog'
    });
  }

}
